import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class MapService {
	private AdvancedMarkerElement: any;
	private Map: any;

	async create(elementId: string, options: { lat: number; long: number; zoom: number }): Promise<google.maps.Map> {
		await this.init();

		const el = document.getElementById(elementId) as HTMLElement;

		const map = new this.Map(el, {
			center: { lat: options.lat, lng: options.long },
			zoom: options.zoom,
			zoomControl: true,
			mapId: 'b04f257d6950461f',
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
		});

		const transitLayer = new google.maps.TransitLayer();
		transitLayer.setMap(map);

		return map;
	}

	createAdvancedMarker(map: google.maps.Map, lat: number, long: number, content: any): any {
		return new this.AdvancedMarkerElement({
			map: map,
			position: {
				lat,
				lng: long,
			},
			content,
		});
	}

	private async init(): Promise<void> {
		if (!this.AdvancedMarkerElement) {
			const { Map } = (await google.maps.importLibrary('maps')) as google.maps.MapsLibrary;
			this.Map = Map;

			const { AdvancedMarkerElement } = (await google.maps.importLibrary('marker')) as google.maps.MarkerLibrary;
			this.AdvancedMarkerElement = AdvancedMarkerElement;
		}
	}
}
